import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate} from 'react-router-dom';
import { ApiProvider } from './ApiContext';
import NavBar from './NavBar';
import MobileNavBar from './MobileNavBar';
import Footer from './Footer';
import Landing from './Landing';
import Products from './Products';
import Compare from './Compare';
import GrassFind from './GrassFind';
import MaizeSelect from './MaizeSelect';
import SeedMix from './SeedMix';
import AboutUs from './AboutUs';
import MeetTheTeam from './MeetTheTeam';
import AgentFind from './AgentFind';
import Careers from './Careers';
import Contact from './Contact';
import Blogs from './Blogs';
import Videos from './Videos';
import Checkout from './Checkout';
import BasketProvider from './BasketContext';
import PrivacyPolicy from './PrivacyPolicy';
import './App.css';

function RouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const validRoutes = [
      "/", "/products", "/compare", "/grass", "/maize", "/mixer",
      "/about-us", "/team", "/agents", "/careers", "/contact",
      "/blogs", "/videos", "/tractor", "/privacy-policy"
    ];

    if (!validRoutes.includes(location.pathname)) {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 850);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      <BasketProvider>
        <ApiProvider>
          <div className="App">
            {isMobile ? <MobileNavBar /> : <NavBar />}
            <div className="content">
              <RouteGuard />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/products" element={<Products />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/grass" element={<GrassFind />} />
                <Route path="/maize" element={<MaizeSelect />} />
                <Route path="/mixer" element={<SeedMix />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/team" element={<MeetTheTeam />} />
                <Route path="/agents" element={<AgentFind />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/tractor" element={<Checkout />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </ApiProvider>
      </BasketProvider>
    </Router>
  );
}

export default App;
